import basisTheoryCheckoutEngine from 'payments/core/engines/basisTheory';
import { registerHandler } from '../paymentHandlerRegistry';

/**
 * Submit the mounted Basis Theory checkout when it owns card capture. Its priority puts it ahead
 * of every engine handler, whatever the registration order in the handlers barrel.
 */
registerHandler('credit_card', {
  priority: 1,
  canHandle: ({ cardCheckoutMode }) => cardCheckoutMode === 'basis_theory',
  execute: async () => basisTheoryCheckoutEngine.submit(),
});
